import { Box, HStack, SimpleGrid, Spinner, Stack, Text } from '@chakra-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { QuestionnaireTemplateStore } from '../../store/questionnaireTemplateModel';
import { FormBuilderHeader } from '../header/FormBuilderHeader';
import { useDragAndDrop } from '../hooks/useDragAndDrop';
import { FormBuilderElementList } from '../toolbox/FormBuilderElementList';
import { Canvas } from './Canvas';
import { DragPreviewPortal } from './DragPreviewPortal';

export const FormBuilderArea = () => {
  const { t } = useTranslation('questionnaireTemplate');
  const { handleDragMove } = useDragAndDrop();
  const isCreatingTemplate = QuestionnaireTemplateStore.useStoreState((s) => s.isCreatingTemplate);

  return (
    <Box style={{ position: 'relative' }}>
      {isCreatingTemplate && (
        <Box
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(255,255,255,0.6)',
            zIndex: 9999,
            cursor: 'not-allowed',
            pointerEvents: 'none',
            userSelect: 'none',
            touchAction: 'none',
            backdropFilter: 'blur(5px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <HStack>
            <Spinner size="md" />
            <Text fontSize="md">{t('formBuilder.templateLoadingText')}</Text>
          </HStack>
        </Box>
      )}

      <SimpleGrid templateColumns="352px 1fr" onPointerMove={handleDragMove}>
        <FormBuilderElementList />
        <Stack spacing="0">
          <FormBuilderHeader />
          <Canvas />
        </Stack>
        <DragPreviewPortal />
      </SimpleGrid>
    </Box>
  );
};
